import { render, staticRenderFns } from "./ComplianceOutstandingActions.vue?vue&type=template&id=829e534c&"
import script from "./ComplianceOutstandingActions.vue?vue&type=script&lang=ts&"
export * from "./ComplianceOutstandingActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports